<template>
  <CatalogueList />
</template>

<script>
import CatalogueList from '@/components/Purchase/Catalogue/CatalogueList.vue'

export default {
  name: 'purchase.catalogue',
  components: { CatalogueList },
}
</script>
